import { createGlobalStyle } from "styled-components";

const colors = {
  primary: '#0052CC',
  background: '#f8f9fa',
  cardBackground: '#FFFFFF',
  textPrimary: '#172B4D',
  textSecondary: '#6B778C',
  border: '#DFE1E6',
  success: '#28a745',
  danger: '#dc3545',
};
export const DevExtremeModalGlobalStyles = createGlobalStyle`
  /* Contenedor principal del modal (sombra y bordes) */
  .dx-popup-wrapper .dx-popup-content {
    border-radius: 8px !important;
    box-shadow: 0 8px 16px -4px rgba(9, 30, 66, 0.25),
      0 0 2px rgba(9, 30, 66, 0.08) !important;
    padding: 0 !important;
  }

  /* Título naranja */
  .dx-overlay-content .dx-popup-title {
    padding: 16px 24px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    background-color: #F8981D !important; 

    
    .dx-toolbar-label {
      font-size: 18px !important;
      font-weight: 600 !important;
      color: white !important;
    }

    .dx-closebutton .dx-icon {
      color: white !important;
    }
  }

  /* Contenido del formulario dentro del modal (espaciado) */
  .dx-popup-content .dx-form {
      padding: 24px;
      background-color: #FFFFFF; /* Asegura fondo blanco */
  }

  /* ... (Estilos de inputs y etiquetas sin cambios) ... */
  .dx-textbox, .dx-selectbox, .dx-datebox {
  }
  .dx-form-item > .dx-field-item-label {
    font-weight: 600 !important;
  }

  /* Barra inferior de botones (fondo unificado) */
  .dx-popup-bottom {
      padding: 16px 24px;
      //border-top: 1px solid ${colors.border};
      background-color: #FFFFFF !important; /* <-- CAMBIO CLAVE: Fondo blanco para unificar */
  }
`;